import { Control } from 'react-hook-form';
import {
    IApplyNowCandidateInformationForm,
    ApplyNowFormValues,
    UploadFileTypes,
} from '../../../../common';
import {
    Grid,
    FormCheckbox,
    FormSelector,
    IOption,
    Typography,
    useTheme,
} from '../../../../base';
import CandidateForm from '../../../CandidateForm';
import FormUploadFile from '../../../../base/base-forms/FormUploadFile';
import { useTranslation } from 'react-i18next';

interface CandidateInformationStepProps {
    control: Control<IApplyNowCandidateInformationForm>;
    isEmployerPortal: boolean;
    publishedJobsOptions: IOption[];
}

const CandidateInformationStep = (props: CandidateInformationStepProps) => {
    const { control, isEmployerPortal, publishedJobsOptions } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Grid container spacing={1} minHeight="min-content" width="100%">
            <Grid item xs={12} pb={1}>
                <Typography variant="body1">
                    {t('applyNow.candidateInfoTitle')}
                </Typography>
            </Grid>
            {isEmployerPortal && (
                <Grid item xs={12}>
                    <FormSelector
                        name={ApplyNowFormValues.jobApplicationId}
                        control={control}
                        options={publishedJobsOptions}
                        label={t('applyNow.selectAPosition')}
                    />
                </Grid>
            )}
            <CandidateForm
                control={control}
                name={ApplyNowFormValues.firstName}
                lastName={ApplyNowFormValues.lastName}
                phoneNumber={ApplyNowFormValues.phoneNumber}
                email={ApplyNowFormValues.email}
            />
            <Grid item xs={12}>
                <Typography variant="h6">
                    {t('applyNow.uploadResume')}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="caption" color={theme.palette.grey[600]}>
                    {t('applyNow.pleaseUploadResume')}
                </Typography>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="center">
                <FormUploadFile
                    name={ApplyNowFormValues.file}
                    type={UploadFileTypes.file}
                />
            </Grid>
            <Grid item xs={12} mt={2}>
                <FormCheckbox
                    name={ApplyNowFormValues.isReferrer}
                    control={control}
                    label={
                        <Typography variant="body2">
                            {t('applyNow.isReferrer')}
                        </Typography>
                    }
                />
            </Grid>
        </Grid>
    );
};

export default CandidateInformationStep;
